import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
import 'swiper/components/pagination/pagination.less'
import { IconFont } from '@/components'
import { Typography, Tooltip } from 'antd'
import { t } from '@/i18n'
SwiperCore.use([Autoplay, Navigation, Pagination])
const DetailLog = props => {
  const { index, data } = props
  const [isRaw, setIsRaw] = useState(false)
  const [num, setNum] = useState(undefined)
  useEffect(() => {
    setNum(index)
  }, [index])

  const filtration = [
    { id: 'datasource_name', name: t('日志源'), disabled: false },
    { id: 'device_ip', name: t('设备IP'), disabled: false },
    { id: 'commander', name: t('负责人'), disabled: false },
    { id: 'cve_id', name: 'CVE_ID', disabled: false },
    { id: 'cnvd_id', name: 'CNVD_ID', disabled: false },
    { id: 'sip', name: t('源IP'), disabled: false },
    { id: 'sport', name: t('源端口'), disabled: false },
    { id: 'dip', name: t('目的IP'), disabled: false },
    { id: 'dport', name: t('目的端口'), disabled: false },
    { id: 'alert_name', name: t('告警名称'), disabled: false },
    { id: 'protocol', name: t('协议'), disabled: false },
    { id: 'x_forward_for', name: 'X_forward_for', disabled: false },
    { id: 'url', name: 'Url', disabled: false },
    { id: 'host', name: 'Host', disabled: false },
    { id: 'asbas_id', name: 'Asbas-Id', disabled: false },
    { id: 'method', name: t('请求方法'), disabled: false },
    { id: 'rule_name', name: t('关联安全设备规则名称'), disabled: false },
    { id: 'rule_id', name: t('关联安全设备规则ID'), disabled: false },
    { id: 'alert_time', name: t('原始告警日志时间'), disabled: false },
    { id: 'alert_level', name: t('告警等级'), disabled: false },
    { id: 'handle_action', name: t('处置动作'), disabled: false },
  ]

  return (
    <>
      {num !== undefined && (
        <LogItem>
          <div className="line">
            <>
              {data?.device_type === 'SOC' ? (
                <div style={{ marginLeft: 6, marginRight: 6, marginTop: -4 }}>
                  <TagAlarm color={'#FF7787'} scale>
                    SOC
                  </TagAlarm>
                </div>
              ) : null}
            </>
            <div className="title" style={{ width: '56px' }}>
              {t('设备IP：')}
            </div>
            <div className="name" style={{ marginRight: '12px' }}>
              <Tooltip title={data?.device_ip || ''} placement="topLeft">
                <span
                  style={{
                    width: 'calc(100% - 85px - 12px)',
                    minWidth: '190px',
                    display: 'inline-block',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {data?.device_ip || '-'}
                </span>
              </Tooltip>
            </div>
            <div className="title" style={{ width: '70px' }}>
              {t('设备类型：')}
            </div>
            <div className="name">{data?.device_type || '-'}</div>
            <div style={{ display: 'flex' }}>
              {data?.log_alarm === 1 && <TagAlarm color={'#F44F4F'}>{t('有告警')}</TagAlarm>}
              {data?.log_alarm === 2 && <TagAlarm color={'#3586ff'}>{t('无告警')}</TagAlarm>}
              {data?.device_status === 'DEVICE_STATUS_INTERCEPT_SUCCESS' && (
                <span className="intercept">{t('拦截成功')}</span>
              )}
              {data?.device_status === 'DEVICE_STATUS_DETECT_SUCCESS' && (
                <span className="intercept-err" style={{ color: '#72b851', background: '#e9f5e3' }}>
                  {t('检测成功')}
                </span>
              )}
              {data?.device_status === 'DEVICE_STATUS_DEFENSE_FAILURE' && (
                <span className="intercept-err">{t('防护失效')}</span>
              )}
              {data?.device_status === 'DEVICE_STATUS_NOT_INVOLVED' && (
                <TagAlarm color={'#2973ff'}>{t('不涉及')}</TagAlarm>
              )}
            </div>
          </div>
          <div className="line">
            <div className="title">{t('设备名称：')}</div>
            <div className="page">
              <>
                <Typography.Text
                  ellipsis={{
                    tooltip: { title: data?.device_name, getPopupContainer: () => document.body },
                  }}
                >
                  <span style={{ color: '#86909C' }}>{data?.device_name || '-'}</span>
                </Typography.Text>
              </>
              {data?.device_log?.length > 0 && (
                <Tabs>
                  <div
                    className={isRaw ? 'tab' : 'active tab'}
                    onClick={() => {
                      setIsRaw(false)
                    }}
                  >
                    {t('解析日志')}
                  </div>
                  <div
                    className={isRaw ? 'active tab' : 'tab'}
                    onClick={() => {
                      setIsRaw(true)
                    }}
                  >
                    {t('原始日志')}
                  </div>
                </Tabs>
              )}
            </div>
          </div>
          {data?.device_log?.length > 0 && (
            <>
              <div className="line">
                <div className="title">{t('日志数量：')}</div>
                <div className="page">
                  <div className={`pag pag${num}`} />
                  <div style={{ display: data?.device_log?.length === 1 ? 'none' : 'block' }}>
                    <div className={`prev less-prev${num}`}>
                      <IconFont type="icon-fanhui2" style={{ fontSize: '12px' }} />
                    </div>
                    <div className={`prev next less-next${num}`}>
                      <IconFont type="icon-fanhui2" style={{ fontSize: '12px' }} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="content1">
                <Swiper
                  spaceBetween={20}
                  navigation={{
                    prevEl: `.less-prev${num}`,
                    nextEl: `.less-next${num}`,
                    hideOnClick: true,
                  }}
                  pagination={{
                    type: 'fraction',
                    el: `.pag${num}`,
                  }}
                  loop
                >
                  {data?.device_log?.map((item, i) => (
                    <SwiperSlide key={i}>
                      {isRaw ? (
                        <>
                          {item?.origin_device_ip === '' ? null : (
                            <div style={{ marginBottom: '12px' }}>
                              <span>
                                {t('原始设备ip:')} {item?.origin_device_ip}
                              </span>
                            </div>
                          )}
                          {item?.origin_device_type === '' ? null : (
                            <div style={{ marginBottom: '12px' }}>
                              <span>
                                {t('原始设备类型:')} {item?.origin_device_type}
                              </span>
                            </div>
                          )}
                          {item?.origin_device_brand === '' ? null : (
                            <div style={{ marginBottom: '12px' }}>
                              <span>
                                {t('设备厂商:')} {item?.origin_device_brand}
                              </span>
                            </div>
                          )}
                          <div style={{ display: 'flex' }}>
                            <Typography.Paragraph
                              style={{ marginRight: '4px' }}
                              copyable={{
                                text: item.message,
                                icon: [
                                  <IconFont
                                    className="icon"
                                    key={1}
                                    type="icon-fuzhi"
                                    style={{ color: '#999999' }}
                                  />,
                                ],
                              }}
                            />

                            <div className="log-content">{item.message}</div>
                          </div>
                        </>
                      ) : (
                        <>
                          {item?.origin_device_ip === '' ? null : (
                            <div style={{ marginBottom: '12px' }}>
                              <span>
                                {t('原始设备ip:')} {item?.origin_device_ip}
                              </span>
                            </div>
                          )}
                          {item?.origin_device_type === '' ? null : (
                            <div style={{ marginBottom: '12px' }}>
                              <span>
                                {t('原始设备类型:')} {item?.origin_device_type}
                              </span>
                            </div>
                          )}
                          {item?.origin_device_brand === '' ? null : (
                            <div style={{ marginBottom: '12px' }}>
                              <span>
                                {t('设备厂商:')} {item?.origin_device_brand}
                              </span>
                            </div>
                          )}
                          <div style={{ display: 'flex' }}>
                            <Typography.Paragraph
                              style={{ marginRight: '4px' }}
                              copyable={{
                                text: filtration
                                  .map(e => {
                                    const value =
                                      e.id === 'alert_time' && !item[e.id]
                                        ? item.recv_time
                                        : item[e.id]
                                    return `${e.name}: ${value || 'null'}`
                                  })
                                  .join('\n'),
                                icon: [
                                  <IconFont
                                    className="icon"
                                    key={1}
                                    type="icon-fuzhi"
                                    style={{ color: '#999999' }}
                                  />,
                                ],
                              }}
                            />

                            <div className="log-content">
                              {filtration.map(el => {
                                const displayValue =
                                  el.id === 'alert_time' && !item[el.id]
                                    ? item.recv_time
                                    : item[el.id]
                                return (
                                  <div key={el.id} style={{ marginBottom: '4px' }}>
                                    <span className="light"> {el.name}: </span>
                                    {el.name === t('处置动作') ? (
                                      <HandleAction type={displayValue}>
                                        {displayValue || 'null'}
                                      </HandleAction>
                                    ) : (
                                      <span>{displayValue || 'null'}</span>
                                    )}
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        </>
                      )}
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </>
          )}
        </LogItem>
      )}
    </>
  )
}

export default DetailLog

const LogItem = styled.div`
  margin-bottom: 24px;
  .line {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    .title {
      width: 88px;
    }
    .name {
      display: flex;
      justify-content: space-between;
      max-width: 200px;
      color: #86909c;
    }
    .page {
      display: flex;
      width: calc(98% - 88px - 18px);
      justify-content: space-between;
      align-items: center;
      .pag {
        max-width: 50px;
        color: #86909c;
      }
    }
  }
  .content1 {
    color: #666666;
    border-radius: 4px;
    width: calc(98% - 18px);
    background: #f7f8fa;
    padding: 10px;
  }
  .log-content {
    word-break: break-all;
    line-height: 1.4;
    height: 122px;
    overflow-y: auto;
    .light {
      color: #558492;
    }
  }
  .prev {
    display: inline-flex;
    width: 24px;
    height: 24px;
    box-shadow: 0px 2px 4px 0px rgba(95, 103, 129, 0.06);
    border-radius: 6px;
    border: 1px solid #d9d9d9;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    &:hover {
      border: 1px solid #4238c9;
    }
  }
  .next {
    transform: rotateY(180deg);
  }
  .swiper-button-disabled {
    &:hover {
      cursor: no-drop;
      background: #d9d9d9 !important;
    }
  }
  .swiper-pagination-current {
    color: #558492;
  }
`
interface TagProps {
  color: string
  scale?: boolean
}
const TagAlarm = styled.div<TagProps>`
  width: ${props => (props.scale ? '35px' : '47px')};
  height: 20px;
  border-radius: 4px;
  color: #fff;
  display: inline-block;
  background: ${props => props.color};
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  margin-left: 8px;
`
const Tag = styled.div`
  color: #fff;
  display: inline-block;
  padding: 1px 3px;
  background: #558492;
  border-radius: 4px;
  margin-right: 2px;
  font-size: 12px;
`

const Tabs = styled.div`
  width: 128px;
  height: 24px;
  font-size: 12px;
  background: #e5e8ed;
  box-shadow: 0px 4px 6px 0px rgba(95, 103, 129, 0.06);
  border-radius: 6px;
  display: flex;
  .tab {
    cursor: pointer;
    width: 64px;
    height: 24px;
    color: #666666;
    background: #e5e8ed;
    border-radius: 6px;
    line-height: 24px;
    text-align: center;
  }
  .active {
    background: #4238c9;
    color: #fff;
  }
`
interface HandleActionProps {
  type: string
}
const HandleAction = styled.span<HandleActionProps>`
  padding: 0 4px;
  color: ${props =>
    props.type === t('放行') ? '#9ed67f' : props.type === t('拦截') ? '#f56969' : ''};
  background: ${props =>
    props.type === t('放行') ? '#e5f1da' : props.type === t('拦截') ? '#fde5e5' : ''};
`
